import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";

// import Home from "./pages/dashboard/Home";
// import Target from "./pages/dashboard/Target";
// import Scan from "./pages/dashboard/Scan";
import DashboardLayout from "./layouts/DashboardLayout";
import Targets from "./pages/dashboard/Targets";
import Inventory from "./pages/dashboard/Inventory";
// import Setting from "./pages/dashboard/Setting";
// import AllReports from "./pages/dashboard/AllReports";
import ScanHistory from "./pages/dashboard/ScanHistory";
import Dashboard from "./pages/dashboard";
// import OldReport from "./pages/dashboard/OldReport";
import Report from "./pages/dashboard/Report";
// import Roles from "./pages/dashboard/Roles";
import Insights from "./pages/dashboard/Insights";
import Credentials from "./pages/dashboard/Credentials";
import Team from "./pages/dashboard/Team";
// import ResetPassword from "./pages/auth/ResetPassword";
import ValidateInvite from "./pages/auth/ValidateInvite";
import PublicRoutes from "./lib/PublicRoutes";
import PrivateRoutes from "./lib/PrivateRoutes";
import WebScanReport from "./pages/dashboard/WebScanReport";
import TargetList from "./pages/dashboard/Targets/TargetList";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route element={<PublicRoutes />}>
            <Route path="/" element={<Login />} />
            <Route path="/register" element={<Register />} />
            {/* <Route path="/reset-password" element={<ResetPassword />} /> */}
            <Route
              path="/api/auth/magic-link/verify"
              element={<ValidateInvite />}
            />
          </Route>
          <Route
            element={
              <PrivateRoutes allowedRoles={["Viewer", "Editor", "Admin"]} />
            }
          >
            <Route element={<DashboardLayout />}>
              <Route path="/dashboard">
                <Route index element={<Dashboard />} />
                {/* <Route path="home" element={<Home />} /> */}
                {/* <Route path="target" element={<Target />} /> */}
                <Route path="assets" element={<Targets />} />
                <Route path="inventory" element={<Inventory />} />
                <Route path="assets/:id" element={<TargetList />} />
                {/* <Route path="scans" element={<Scan />} /> */}
                <Route path="scan-history" element={<ScanHistory />} />
                <Route path="scan-history/:id" element={<ScanHistory />} />
                {/* <Route path="report" element={<AllReports />} /> */}
                {/* <Route path="view-report" element={<OldReport />} /> */}
                <Route path=":id/report" element={<Report />} />
                <Route path="web-scan/:id/report" element={<WebScanReport />} />
                {/* <Route path="roles" element={<Roles />} /> */}
                <Route path="insights" element={<Insights />} />
                {/* <Route path="settings" element={<Setting />} /> */}

                {/* Only Editors + Admins */}
                <Route
                  element={<PrivateRoutes allowedRoles={["Editor", "Admin"]} />}
                >
                <Route path="credentials" element={<Credentials />} />
                </Route>

                <Route
                  element={<PrivateRoutes allowedRoles={["Editor", "Admin"]} />}
                >
                  <Route path="team" element={<Team />} />
                </Route>

              </Route>
            </Route>
          </Route>
        </Routes>
      </Router>
      <ToastContainer position="top-right" duration={3000} />
    </>
  );
}

export default App;
